import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { productFormIdZodSchema } from "../product-form-id";
import { checkboxDataZodObject } from "./data-checkbox";
import { selectDataZodObject } from "./data-select";
import { textDataZodObject } from "./data-textbox";

const _commandBaseZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("PRODUCT_FORM_EDIT_FIELD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    productId: productIdZodSchema,
    productFormId: productFormIdZodSchema,
});

const productFormEditCheckboxFieldCommandZodObject =
    _commandBaseZodObject.merge(
        z.object({
            field: checkboxDataZodObject,
        }),
    );
type ProductFormEditCheckboxFieldCommand = z.infer<
    typeof productFormEditCheckboxFieldCommandZodObject
>;

const productFormEditSelectFieldCommandZodObject = _commandBaseZodObject.merge(
    z.object({
        field: selectDataZodObject,
    }),
);
type ProductFormEditSelectFieldCommand = z.infer<
    typeof productFormEditSelectFieldCommandZodObject
>;

const productFormEditTextFieldCommandZodObject = _commandBaseZodObject.merge(
    z.object({
        field: textDataZodObject,
    }),
);
type ProductFormEditTextFieldCommand = z.infer<
    typeof productFormEditTextFieldCommandZodObject
>;

const productFormEditFieldCommandZodObject = _commandBaseZodObject.merge(
    z.object({
        field: z.union([
            checkboxDataZodObject,
            textDataZodObject,
            selectDataZodObject,
        ]),
    }),
);
type ProductFormEditFieldCommand = z.infer<
    typeof productFormEditFieldCommandZodObject
>;

const factoryParamsZodObject = productFormEditFieldCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormEditFieldCommandFactory = (
    params: FactoryParams,
): ProductFormEditFieldCommand => {
    return {
        ...params,
        _id: generateId({ prefix: "product_form_edit_field_command__" }),
        _type: "PRODUCT_FORM_EDIT_FIELD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

export {
    productFormEditCheckboxFieldCommandZodObject,
    productFormEditFieldCommandFactory,
    factoryParamsZodObject as productFormEditFieldCommandFactoryParamsZodObject,
    productFormEditFieldCommandZodObject,
    productFormEditSelectFieldCommandZodObject,
    productFormEditTextFieldCommandZodObject,
};
export type {
    ProductFormEditCheckboxFieldCommand,
    ProductFormEditFieldCommand,
    FactoryParams as ProductFormEditFieldCommandFactoryParams,
    ProductFormEditSelectFieldCommand,
    ProductFormEditTextFieldCommand,
};
